import React from 'react';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import CapitalBalanceListView from './components/CapitalBalanceListView';
import { FISCAL_CAPITAL_BALANCE_CONFIG } from './config';

const FiscalCapitalBalanceListPage = () => (
  <CapitalBalanceListView config={FISCAL_CAPITAL_BALANCE_CONFIG} />
);

const FiscalCapitalBalanceView = () => {
  return (
    <>
      <RolePrivateRoute
        component={FiscalCapitalBalanceListPage}
      />
    </>
  );
};


export default FiscalCapitalBalanceView;
